class BlockFAQ{
	constructor(blockEl) {
		this.blockEl = blockEl;
		
		this.setupEventHandlers();
		
	}
	
	setupEventHandlers() {
		const faqSections = this.blockEl.querySelectorAll('.block-faq__section');
		faqSections.forEach(i => {
			const clickRegion = i.querySelector('.block-faq__question-container');
			const content = i.querySelector('.block-faq__content');
			clickRegion.addEventListener('click', () => {
				content.classList.toggle('open');
			});
		
		})

	}

}

export default BlockFAQ;